// src/components/AddTenant.js
import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

const AddTenant = () => {
  const { loginWithRedirect, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [formData, setFormData] = useState({
    customerName: '',
    customerSubdomain: '',
    product: '',
    expiryTime: '',
    userName: '',
    userEmail: '',
    userJobTitle: ''
  });

  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null); // { type: 'success' | 'error', message: string }
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isAuthenticated) {
      loginWithRedirect();
      return;
    }

    setLoading(true);
    setAlert(null);

    try {
      const token = await getAccessTokenSilently({
        audience: 'https://your-api-endpoint',
        scope: 'create:tenants'
      });

      const response = await axios.post('https://api.sevis.click/admin/tenants', formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setAlert({ type: 'success', message: '🎉 Tenant created successfully!' });
      setFormData({
        customerName: '',
        customerSubdomain: '',
        product: '',
        expiryTime: '',
        userName: '',
        userEmail: '',
        userJobTitle: ''
      });

      //setMessage('Tenant created successfully.');
    } catch (error) {
      console.error('Error creating tenant:', error);
      //setMessage('Failed to create tenant. Ensure you have the required permissions.');
      setAlert({ type: 'error', message: '❌ Failed to create tenant. Check console and ensure you have the right permissions.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Add Tenant</h2>

      {alert && (
        <div
          style={{
            ...styles.alert,
            backgroundColor: alert.type === 'success' ? '#d4edda' : '#f8d7da',
            color: alert.type === 'success' ? '#155724' : '#721c24'
          }}
        >
          {alert.message}
        </div>
      )}

      <form onSubmit={handleSubmit} style={styles.form}>
        <fieldset style={styles.fieldset}>
          <legend style={styles.legend}>Tenant Details</legend>
          <input
            type="text"
            name="customerName"
            placeholder="Customer Name"
            value={formData.customerName}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="text"
            name="customerSubdomain"
            placeholder="Customer Subdomain"
            value={formData.customerSubdomain}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="text"
            name="product"
            placeholder="Product"
            value={formData.product}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="text"
            name="expiryTime"
            placeholder="Expiry Time"
            value={formData.expiryTime}
            onChange={handleChange}
            style={styles.input}
          />
        </fieldset>

        <fieldset style={styles.fieldset}>
          <legend style={styles.legend}>Initial User Details</legend>
          <input
            type="text"
            name="userName"
            placeholder="User Name"
            value={formData.userName}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="email"
            name="userEmail"
            placeholder="User Email"
            value={formData.userEmail}
            onChange={handleChange}
            required
            style={styles.input}
          />
          <input
            type="text"
            name="userJobTitle"
            placeholder="Job Title (optional)"
            value={formData.userJobTitle}
            onChange={handleChange}
            style={styles.input}
          />
        </fieldset>

        {/* <button type="submit" style={styles.button}>Add Tenant</button>*/}
        <button type="submit" disabled={loading} style={styles.button}>
          {loading ? 'Creating...' : 'Add Tenant'}
        </button>
      </form>

      {/* {message && <p style={styles.message}>{message}</p>} */}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '2rem'
  },
  heading: {
    textAlign: 'center'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  fieldset: {
    border: '1px solid #ccc',
    borderRadius: '8px',
    padding: '1rem'
  },
  legend: {
    fontWeight: 'bold',
    marginBottom: '0.5rem'
  },
  input: {
    padding: '0.5rem',
    fontSize: '1rem',
    marginBottom: '0.75rem',
    width: '100%',
    boxSizing: 'border-box'
  },
  button: {
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  message: {
    marginTop: '1rem',
    textAlign: 'center'
  },
  alert: { padding: '1rem', borderRadius: '4px', marginBottom: '1rem' }
};

export default AddTenant;
